// @ts-generator-hash: 03e1e8d76b82d2c3185660ec908220ca560f92058ef9037525ca0a6532bb2655
// Generation date: 9/1/2026 3:57:56 AM
// Auto-generated by CSharpToTypeScriptConverter
// Based on type: C06Camera.DL.Domain.AuditActorType
export enum AuditActorType {
  User = 0,
  External = 1,
  System = 2,
}
